import { render, staticRenderFns } from "./thesis.vue?vue&type=template&id=7a8220a6&scoped=true"
import script from "./thesis.vue?vue&type=script&lang=js"
export * from "./thesis.vue?vue&type=script&lang=js"
import style0 from "./thesis.vue?vue&type=style&index=0&id=7a8220a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8220a6",
  null
  
)

export default component.exports